import { DefaultActions, Separator, Showing, Total, Search, Wrapper } from '@/components/Grid/components/header/Heading';
import { GridProvider, useBuildGrid, DefaultGrid } from '@Components/Grid';

import { useContestsStore } from '../../store';

import useColumns from './useColumns'
import useDefinitions from './useDefinitions'
import useFilters from './useFilters'

function ContestGrid() {
  useBuildGrid({
    definitions: useDefinitions(),
    columns: useColumns(),
    filters: useFilters(),
  })

  return <DefaultGrid
    heading={<Wrapper>
      <Search />
      <Separator />
      <Total />
      <Showing />
      <Separator />
      <DefaultActions add={null} />
    </Wrapper>}
  />
}

export default function ContestGridLayout() {
  return <GridProvider store={useContestsStore()}>
    <ContestGrid />
  </GridProvider>
}
